"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CfgCountryListRu = /** @class */ (function () {
    function CfgCountryListRu() {
    }
    CfgCountryListRu.getLangData = function () {
        return {
            document_title: "Страны",
            editor: {
                breadcrumb: {
                    new_country: ["Создание страны"],
                    edit_country: ["Редактирование страны"]
                },
                message: {
                    country_added: "Страна добавлена!",
                    country_changed: "Страна изменена!"
                },
                error: {
                    field_title_empty: "Поле [название] не заполнено!",
                    field_code_empty: "Поле [код] не заполнено!",
                },
                title: {
                    new_country: "Добавить страну",
                    edit_country: "Изменить страну",
                },
                fields: {
                    title: {
                        caption: "Название:",
                        placeholder: "Введите название",
                    },
                    code: {
                        caption: "Код:",
                        placeholder: "Введите код",
                    }
                },
                checkboxes: {
                    deprecated: "Страна устарела",
                    unknown: "Страна неизвестна"
                },
                buttons: {
                    save: "Сохранить",
                    create: "Создать",
                    back: "Вернуться",
                }
            }, list: {
                message: {
                    set_as_actual_fmt: "Страна {0} помечена как актуальная",
                    set_as_deprecated_fmt: "Страна {0} помечена как устаревшая",
                    country_deleted_fmt: "Страна {0} была успешно удалена",
                    all_country_deprecated: "Все страны помечены как неактуальные !",
                    all_country_actual: "Все страны помечены как актуальные !"
                },
                rows: {
                    title: "Название",
                    code: "Код",
                    date_added: "Добавлен",
                    deprecated: {
                        title: "Актуальная",
                        menu: {
                            actual: {
                                menu: "Пометить как актуальный",
                                text: "Да"
                            },
                            deprecate: {
                                menu: "Пометить как устаревший",
                                text: "Нет"
                            }
                        },
                        filter: {
                            actual: "Актуальная",
                            deprecate: "Устаревшая",
                        }
                    },
                    unknown: {
                        title: "Неизвестный",
                        filter: {
                            unknown: "Неизвестный",
                            known: "Известный",
                        },
                        render: {
                            yes: "Да",
                            no: "Нет"
                        }
                    },
                    action: {
                        title: "Действия",
                        edit: "Изменить",
                        delete: {
                            hint: "Удалить",
                            confirm: "Удалить эту запись ?",
                        }
                    }
                },
                toolbars: {
                    hints: {
                        create: "Создать",
                        refresh: "Обновить",
                    },
                    lock_all: {
                        confirm_title: "Отметить как не актуальные ?",
                        ok_text: "Да",
                        cancel_text: "Нет",
                        button_hint: "Отметить как не актуальные"
                    },
                    unlock_all: {
                        confirm_title: "Отметить как актуальные ?",
                        ok_text: "Да",
                        cancel_text: "Нет",
                        button_hint: "Отметить как актуальные"
                    }
                },
                footer: {
                    title_fmt: "Отображается на странице : {0} из {1} записей",
                },
                details: {
                    created: "Создан:",
                    changed: "Изменен:",
                }
            }
        };
    };
    return CfgCountryListRu;
}());
exports.CfgCountryListRu = CfgCountryListRu;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_country/ui/lang/CfgCountryListRu.ts
// module id = 2056
// module chunks = 0